<template lang="pug">
  v-icon.ml-2(size="10" :color="isSuccess ? 'success500' : '#C1C1C1'") $yzi-gift-02
</template>

<script>
export default {
  props: {
    isSuccess: {
      type: Boolean,
    },
  },
}
</script>

<style scoped>
</style>